import { useState } from 'react';
import { Eye, EyeOff, Mail, Lock, User, Phone, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Input, Button } from '../ui';

export default function SignUpForm({
  name, email, password, birthday, cellphone,
  setName, setEmail, setPassword, setBirthday, setCellphone,
  handleSubmit, authError, loading,
}) {
  const [showPassword, setShowPassword] = useState(false);

  const handleCelChange = (e) => {
    const raw = e.target.value.replace(/\(|\)|-| /g, '');
    if (raw.match(/[a-zA-Z]/)) return;
    if (raw.length >= 12) return;
    setCellphone(e.target.value);
    if (e.target.value.length === 11) {
      const arr = raw.split('');
      arr.splice(0, 0, '('); arr.splice(3, 0, ')'); arr.splice(4, 0, ' '); arr.splice(10, 0, '-');
      setCellphone(arr.join(''));
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-5" noValidate>
      <div className="flex flex-col gap-1 text-center">
        <h1 className="text-3xl font-bold text-text-primary">Criar conta</h1>
        <p className="text-sm text-text-muted">Preencha seus dados para se cadastrar</p>
      </div>

      <div className="flex flex-col gap-3.5">
        <Input
          label="Nome completo"
          type="text"
          placeholder="Digite seu nome completo"
          autoComplete="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          icon={User}
          required
          disabled={loading}
        />

        <Input
          label="Data de nascimento"
          type="date"
          autoComplete="bday"
          value={birthday}
          onChange={(e) => setBirthday(e.target.value)}
          icon={Calendar}
          required
          disabled={loading}
        />

        <Input
          label="Celular"
          type="text"
          placeholder="(19) 99999-9999"
          autoComplete="tel"
          value={cellphone}
          onChange={handleCelChange}
          icon={Phone}
          required
          disabled={loading}
        />

        <Input
          label="Email"
          type="email"
          placeholder="Digite seu email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          icon={Mail}
          required
          disabled={loading}
        />

        <div className="relative">
          <Input
            label="Senha"
            type={showPassword ? 'text' : 'password'}
            placeholder="Digite sua senha"
            autoComplete="new-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            icon={Lock}
            required
            disabled={loading}
            className="pr-10"
          />
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
            className="absolute right-3 bottom-2.5 text-text-muted hover:text-text-primary transition-colors duration-normal focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-border-focus rounded"
          >
            {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
          </button>
        </div>
      </div>

      {authError && (
        <p role="alert" className="text-sm text-danger-text bg-danger-bg border border-danger rounded-md px-3 py-2">
          {authError}
        </p>
      )}

      <Button type="submit" variant="primary" size="lg" loading={loading} className="w-full">
        Cadastrar
      </Button>

      <p className="text-center text-sm text-text-muted">
        Já tem conta?{' '}
        <Link to="/login" className="text-primary hover:underline font-medium">
          Entrar
        </Link>
      </p>
    </form>
  );
}
